module.exports = __webpack_public_path__ + "img/siliver.fb4c50ce.png";